import type { ButtonProps } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'

export interface DateSelectorItemProps extends ButtonProps {
  isActive?: boolean
}

export const DateSelectorItem = ({
  children,
  isActive,
  ...rest
}: DateSelectorItemProps) => {
  return (
    <Button
      sx={{
        px: 4,
        py: 2,
        pb: 1,
        borderTop: '2px solid',
        borderTopColor: isActive ? 'primary.500' : 'gray.300',
        borderRadius: 0,
        color: isActive ? 'primary.500' : 'gray.500',
        fontWeight: 'medium',
        outline: 'none',
        textDecoration: 'none',
        transition: 'all 0.2s',
        _hover: {
          borderTopColor: 'primary.500',
          textDecoration: 'none',
        },
        _focus: {
          outline: 'none',
        },
        _active: {
          outline: 'none',
        },
      }}
      variant="link"
      {...rest}
    >
      {children}
    </Button>
  )
}
